import {
  filter,
  tap,
  ignoreElements,
  switchMap,
  mergeMap,
  catchError,
} from 'rxjs/operators'
import {of, concat, from} from 'rxjs'
import {Epic} from 'redux-observable'
import {RootState, AppActions} from 'app/rootReducer'
import {AdminService} from 'services/api'
import Toast from 'components/Basic/Toast'
import {adminActions} from '../adminSlice'

const validateURLEpic: Epic<AppActions, AppActions, RootState> = action$ =>
  action$.pipe(
    filter(adminActions.validateURL.match),
    switchMap(({payload}) =>
      from(AdminService.validateURL(payload)).pipe(
        mergeMap(({data}) => [adminActions.validateURLSuccess(data)]),
        catchError((message: string) =>
          concat(of(adminActions.validateURLFailure(message))),
        ),
      ),
    ),
  )

const validateURLFailureEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(adminActions.validateURLFailure.match),
    tap(({payload: message}) => {
      if (message) {
        Toast({message, type: 'error'})
      }
    }),
    ignoreElements(),
  )

export const settingsEpics = [validateURLEpic, validateURLFailureEpic]
